const SafetyData = [
  {
    title: 'NUDITY OR SEXUAL CONTENT',
    content:
      "Raven Livestream is not for pornography or sexually explicit content. If this describes your video or event, even if it's a video or event of you, don't post it on Raven Livestream. Also, be advised that we work closely with law enforcement and we report child exploitation."
  },
  {
    title: 'HARMFUL OR DANGEROUS CONTENT',
    content:
      "Don't post videos that encourage others to do things that might cause them to get badly hurt, especially children.Videos showing such harmful or dangerous acts may get age' restricted or removed depending on their severity. You may not post media that is excessively gory or share violent or adult content within live video or in profile or header images. Media depicting sexual violence and/or assault is also not permitted."
  },
  {
    title: 'SPAM, MISLEADING METADATA, AND SCAMS',
    content:
      "Everyone hates spam. Don't create misleading descriptions, tags, titles, or thumbnails in order to increase views and sell tickets. It's not okay to post large amounts of untargeted, unwanted or repetitive content, including comments and private messages."
  },
  {
    title: 'THREATS',
    content:
      "Things like predatory behavior, stalking, threats, harassment, intimidation, invading privacy, revealing other people's personal information, and inciting others to commit violent acts or to violate the Terms of Use are taken very seriously. Anyone caught doing these things, depending on the severity may be temporarily suspended or permanently banned from Raven Livestream."
  },
  {
    title: 'COPYRIGHT',
    content:
      "Respect copyright! Only broadcast or post content that you made or that you're authorized to use. This means do not broadcast, stream or post videos you didn't make, or use content in your videos that someone else owns the copyright to, such as music tracks, snippets of copyrighted programs, or videos made by other users, without necessary authorizations. You may not deceptively share synthetic or manipulated media that are likely to cause harm. In addition, you may not share content streamed on Raven to other platforms without the consent or permission of the creator."
  },
  {
    title: 'COPYRIGHT AND TRADEMARK',
    content:
      'You may not violate others’ intellectual property rights, including copyright and trademark.'
  },
  {
    title: 'PRIVACY',
    content:
      "You may not publish or post other people's private information (such as home, phone number and address) without their express authorization and permission. We also prohibit threatening to expose private information or incentivizing others to do so."
  },
  {
    title: 'NON-CONSENSUAL NUDITY',
    content:
      'You may not post or share intimate photos or videos of someone that were produced or distributed without their consent. If someone has posted your personal information or broadcasted a video of you without your consent, you can request removal of content based on our Privacy Guidelines.'
  },
  {
    title: 'IMPERSONATION',
    content:
      'You may not impersonate individuals, groups, or organizations in a manner that is intended to or does mislead, confuse, or deceive others. Accounts that are established to impersonate another channel or individuals may be removed under our impersonation policy.'
  },
  {
    title: 'CHILD SAFETY',
    content:
      'We care about the safety of children, therefore any content or user that seeks to harm or violate our policy on child safety will be dealt with. We have zero tolerance for child sexual exploitation. We protect minors in the Raven Livestream ecosystem. Also, be advised that we work closely with law enforcement and we report child endangerment.'
  },
  {
    title: 'INTERNET FRAUD PREVENTION',
    content:
      'Stealing credit & debit card information, phishing, and chargebacks, will not be condoned. You must make sure to avoid or minimize the risk of falling prey to such scams and report such crimes. Be advised that we work closely with law enforcement agencies.'
  },
  {
    title: 'ADDITIONAL POLICIES ON A RANGE OF SUBJECTS',
    content:
      "If a Raven Livestream participant's on-and/or off-platform behavior harms our users, community, employees or ecosystem, we may respond based on a number of factors including, but not limited to, the egregiousness of their actions and whether a pattern of harmful behavior exists. Our response will range from suspending a creator's/users privileges to account termination."
  },
  {
    title: 'THIRD-PARTY ADVERTISING IN VIDEO CONTENT',
    content:
      "If a Raven Livestream participant's on-and/or off-platform behavior harms our users, community, employees or ecosystem, we may respond based on a number of factors including, but not limited to, the egregiousness of their actions and whether a pattern of harmful behavior exists. Our response will range from suspending a creator's/users privileges to account termination."
  }
];

export default SafetyData;
